import { z } from 'zod';

// ============================================================================
// WhatsApp Admin Reply — POST /api/v1/notifications/whatsapp/admin/reply
// ============================================================================

export const WhatsAppReplyRequestSchema = z.object({
  phoneNumber: z.string().min(1),
  body: z.string().min(1),
});

export type WhatsAppReplyRequest = z.infer<typeof WhatsAppReplyRequestSchema>;

export const WhatsAppReplyResponseSchema = z.object({
  data: z.object({
    success: z.boolean(),
    messageSid: z.string(),
  }),
});

export type WhatsAppReplyResponse = z.infer<typeof WhatsAppReplyResponseSchema>;

// ============================================================================
// Conversation Thread — GET /api/v1/notifications/whatsapp/admin/conversations
// ============================================================================

export const WhatsAppConversationThreadSchema = z.object({
  phoneNumber: z.string(),
  lastMessage: z.string(),
  lastMessageAt: z.string().datetime(),
  status: z.string(),
  messageCount: z.number().int(),
});

export type WhatsAppConversationThread = z.infer<typeof WhatsAppConversationThreadSchema>;

export const ListConversationsResponseSchema = z.object({
  data: z.array(WhatsAppConversationThreadSchema),
});

export type ListConversationsResponse = z.infer<typeof ListConversationsResponseSchema>;

// ============================================================================
// Conversation History — GET /api/v1/notifications/whatsapp/admin/conversations/:phoneNumber
// ============================================================================

export const WhatsAppMessageSchema = z.object({
  id: z.string(),
  phoneNumber: z.string(),
  body: z.string(),
  direction: z.enum(['incoming', 'outgoing']),
  messageSid: z.string().nullable(),
  status: z.string().nullable(),
  createdAt: z.string().datetime(),
});

export type WhatsAppMessage = z.infer<typeof WhatsAppMessageSchema>;

export const ConversationHistoryResponseSchema = z.object({
  data: z.array(WhatsAppMessageSchema),
});

export type ConversationHistoryResponse = z.infer<typeof ConversationHistoryResponseSchema>;
